let apiPromise;

export function loadYouTubePlayer() {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (!apiPromise) {
    apiPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const previous = window.onYouTubeIframeAPIReady;
      const timeout = setTimeout(() => fail(), 15000);
      function fail() {
        clearTimeout(timeout);
        script.remove();
        window.onYouTubeIframeAPIReady = previous;
        apiPromise = undefined;
        reject(new Error('YouTube player could not load'));
      }
      window.onYouTubeIframeAPIReady = () => {
        clearTimeout(timeout);
        window.onYouTubeIframeAPIReady = previous;
        resolve(window.YT);
        if (previous) previous();
      };
      script.src = 'https://www.youtube.com/iframe_api';
      script.async = true;
      script.onerror = fail;
      document.head.appendChild(script);
    });
  }
  return apiPromise;
}
